var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoldarrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3743 50.6791L26.8242 39.1291C26.4108 38.7165 26.0828 38.2264 25.859 37.687C25.6352 37.1475 25.52 36.5692 25.52 35.9851C25.52 35.4011 25.6352 34.8227 25.859 34.2833C26.0828 33.7438 26.4108 33.2537 26.8242 32.8412L38.3743 21.2911C41.1837 18.5262 46 20.4884 46 24.4573V47.5129C46 51.5264 41.1837 53.4886 38.3743 50.6791Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldarrowLeft);
export default __webpack_public_path__ + "static/media/boldarrowLeft.47c46800e05a1a02b0d779155d323173.svg";
export { ForwardRef as ReactComponent };